import activityReport from './activityReport'
export default activityReport
